import { createFileRoute } from '@tanstack/react-router'
import { OneCIntegrationPage } from '@/pages/one-c-integration/one-c-integration-page'
import { WorkspaceEntitlementGate } from '@/features/workspace-entitlements/ui/workspace-entitlement-gate'
import { WorkspaceEntitlementKey } from '@/graphql/schema'

export const Route = createFileRoute('/settings/1c')({
  component: () => (
    <WorkspaceEntitlementGate feature={WorkspaceEntitlementKey.OneC}>
      <OneCIntegrationPage />
    </WorkspaceEntitlementGate>
  ),
})
